import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';

@Component({
  selector: 'rr-ai-control-select',
  standalone: false,

  templateUrl: './ai-control-select.component.html',
  styleUrl: './ai-control-select.component.scss'
})
export class AiControlSelectComponent implements OnChanges, AfterViewInit {
  @Input() control: any;
  @Input() text1: string = "";
  @Input() text2: string = "";
  @Input() text3: string = "";
  @Input() interviewPartner: any[] = [];
  @Input() personas: any[] = [];
  optionswidth: number = 0;
  personamargin: number = 0;
  personamarginbottom: number = 0;

  @Output() changeInterviewPartner: EventEmitter<any> = new EventEmitter();
  @Output() changePersonas: EventEmitter<any> = new EventEmitter();
  @Output() start: EventEmitter<any> = new EventEmitter();

  @ViewChild('selected') select!: ElementRef;
  @ViewChild('persona', { static: false }) personaSelect!: ElementRef;

  // ngAfterViewInit(): void {
  //   if (this.select) {
  //     this.optionswidth = this.select.nativeElement.offsetWidth - 12;
  //   }
  // }
  private resizeObserver: ResizeObserver | null = null;

  ngAfterViewInit(): void {
    if (this.select) {
      this.optionswidth = this.select.nativeElement.offsetWidth;

      this.resizeObserver = new ResizeObserver(() => {
        if (this.select) {
          this.optionswidth = this.select.nativeElement.offsetWidth;
        }
      });

      this.resizeObserver.observe(this.select.nativeElement);
    }
  }

  ngOnDestroy(): void {
    if (this.resizeObserver && this.select) {
      this.resizeObserver.unobserve(this.select.nativeElement);
      this.resizeObserver.disconnect();
    }
  }

  selectedInterviewPartner: any = null;
  selectedPersona: any = null;

  showInterViewPartnerOptions: boolean = false;
  showPersonaOptions: boolean = false;

  selectinterviewPartner(interviewPartner: any) {
    this.selectedInterviewPartner = interviewPartner;
    this.showInterViewPartnerOptions = false;
    this.changeInterviewPartner.emit(interviewPartner);
  }
  selectPersona(persona: any) {
    this.selectedPersona = persona;
    this.showPersonaOptions = false;
    this.changePersonas.emit(persona);
  }
  toggleOptions() {
    this.showInterViewPartnerOptions = !this.showInterViewPartnerOptions;
  }
  togglePersonas() {
    this.showPersonaOptions = !this.showPersonaOptions;
    if (this.showPersonaOptions) {
      setTimeout(() => {
        if (this.personaSelect?.nativeElement) {
          this.personamargin = this.optionswidth - this.personaSelect.nativeElement.offsetWidth + 12;
          this.personamarginbottom = 0 - this.personaSelect.nativeElement.offsetHeight - 16;
        }
      });
    }
  }


  ngOnChanges(changes: SimpleChanges) {
    if (changes['interviewPartner']) {
      this.selectedInterviewPartner = this.interviewPartner[0];
    }
    if (changes['personas']) {
      this.selectedPersona = this.personas[0];
    }
  }
}
